import { PanelBody, PanelRow, Button } from "@wordpress/components";
import React from "react";
import { SmartForm } from "../SmartForm";
import FormSetupModal from "./FormSetupModal";


export function SmartFormInspector({ formApi, openModal, setOpenModal }: { formApi: SmartForm; openModal: boolean, setOpenModal: (b: boolean) => void }) {

  return (
    <>
      <PanelBody title="Paramètres" initialOpen={true}>
        <PanelRow>
          <Button variant="primary" onClick={() => setOpenModal(true)}
            icon="email"
            label="Mail settings"
          >
            Mail settings
          </Button>
        </PanelRow>
      </PanelBody>
      <FormSetupModal open={openModal} setOpen={setOpenModal} formApi={formApi} />
    </>
  );

}
